import { useMutation } from "@tanstack/react-query";

import { emailWidgetSnippet } from "./api";

export const useEmailEmbedCode = onSuccess =>
  useMutation({
    mutationFn: emailData => emailWidgetSnippet(emailData),
    onSuccess,
  });
